import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-phone-modal',
  templateUrl: './phone-modal.component.html',
  styleUrls: ['./phone-modal.component.scss'],
})
export class PhoneModalComponent implements OnInit {

  constructor(private modalCtrl: ModalController ) { }

  ngOnInit() {}



  onCancel() {
    this.modalCtrl.dismiss( null, 'cancel' );
  }

}
